import { connect } from 'react-redux';

import { HomepageRootState } from 'apps/homepage/store';
import { InteriorScene } from './Component';

const mapStateToProps = (state: HomepageRootState) => {
  const curatedArtworks = state.artworks.byType['curated'];

  const { currentListing } = state.artworks;
  const listingsExists = Object.keys(curatedArtworks.byId).length > 0;
  const currentListingExists =
    listingsExists && currentListing && curatedArtworks.byId[currentListing];

  return {
    artwork: currentListingExists ? curatedArtworks.byId[currentListing]?.list[0] : null,
  };
};

export const InteriorSceneContainer = connect(mapStateToProps, null)(InteriorScene);
